var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyringe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Health/Medical Syringe",
    clipPath: "url(#clip0_1747_10440)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40805 3.02854C8.62898 3.2539 8.62539 3.61569 8.40003 3.83662L3.1678 8.96603C3.00924 9.12488 2.8834 9.31332 2.79745 9.52067C2.71118 9.72878 2.66677 9.95186 2.66677 10.1771C2.66677 10.4024 2.71118 10.6255 2.79745 10.8336C2.88372 11.0417 3.01016 11.2308 3.16955 11.39L4.60978 12.8302C4.76899 12.9896 4.95828 13.1163 5.16639 13.2026C5.3745 13.2888 5.59757 13.3332 5.82286 13.3332C6.04814 13.3332 6.27122 13.2888 6.47933 13.2026C6.68667 13.1166 6.8751 12.9908 7.03395 12.8322L12.1634 7.59997C12.3843 7.37461 12.7461 7.37102 12.9715 7.59195C13.1968 7.81288 13.2004 8.17467 12.9795 8.40003L7.84805 13.6343L7.84429 13.6381C7.57893 13.9038 7.26382 14.1145 6.91697 14.2583C6.57012 14.4021 6.19833 14.4761 5.82286 14.4761C5.44738 14.4761 5.07559 14.4021 4.72874 14.2583C4.38199 14.1145 4.06696 13.9039 3.80165 13.6383C3.80158 13.6383 3.80173 13.6384 3.80165 13.6383L2.36188 12.1986C2.09623 11.9332 1.88549 11.6181 1.74171 11.2713C1.59792 10.9244 1.52392 10.5526 1.52392 10.1771C1.52392 9.80167 1.59792 9.42988 1.74171 9.08303C1.88549 8.73618 2.09623 8.42107 2.36188 8.15571L2.36568 8.15195L7.59997 3.02052C7.82533 2.79959 8.18712 2.80318 8.40805 3.02854Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5959 0.167368C11.8191 -0.0557892 12.1809 -0.0557892 12.4041 0.167368L15.8326 3.59594C16.0558 3.8191 16.0558 4.1809 15.8326 4.40406C15.6095 4.62722 15.2477 4.62722 15.0245 4.40406L11.5959 0.97549C11.3728 0.752333 11.3728 0.390524 11.5959 0.167368Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1183 1.88165C14.3415 2.10481 14.3415 2.46662 14.1183 2.68978L10.6898 6.11835C10.4666 6.3415 10.1048 6.3415 9.88165 6.11835C9.6585 5.89519 9.6585 5.53338 9.88165 5.31023L13.3102 1.88165C13.5334 1.6585 13.8952 1.6585 14.1183 1.88165Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88978 12.1102C4.11293 12.3334 4.11293 12.6952 3.88978 12.9183L0.97549 15.8326C0.752333 16.0558 0.390524 16.0558 0.167368 15.8326C-0.0557892 15.6095 -0.0557892 15.2477 0.167368 15.0245L3.08165 12.1102C3.30481 11.8871 3.66662 11.8871 3.88978 12.1102Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88165 1.31022C6.10481 1.08707 6.46662 1.08707 6.68978 1.31022L14.6898 9.31022C14.9129 9.53338 14.9129 9.89519 14.6898 10.1183C14.4666 10.3415 14.1048 10.3415 13.8817 10.1183L5.88165 2.11835C5.6585 1.89519 5.6585 1.53338 5.88165 1.31022Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1747_10440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyringe);
export default __webpack_public_path__ + "static/media/syringe.1328586977edf2b4d3b9a4d8b1b2408c.svg";
export { ForwardRef as ReactComponent };